import {
  ChangeDetectorRef,
  Component,
  inject,
  input,
  InputSignal,
  OnDestroy,
  TemplateRef,
} from '@angular/core';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { AppendTestIdPipe } from '../../../pipes/append-test-id/append-test-id.pipe';
import { fromEvent, Subscription } from 'rxjs';

@Component({
  selector: 'aw-extendable-text',
  imports: [NgClass, AppendTestIdPipe, NgTemplateOutlet],
  templateUrl: './extendable-text.component.html',
})
export class ExtendableTextComponent implements OnDestroy {
  public id: InputSignal<string> = input.required();
  public title: InputSignal<string> = input('Details');
  public isExtended: boolean = false;
  public $handleKeyUpEvent!: Subscription;
  public readonly titleTemplate: InputSignal<TemplateRef<unknown> | undefined> =
    input<TemplateRef<unknown> | undefined>();
  public readonly toggle: () => void = () => {
    this.isExtended = !this.isExtended;
  };
  private readonly cdRef: ChangeDetectorRef = inject(ChangeDetectorRef);

  constructor() {
    this.$handleKeyUpEvent = fromEvent<
      KeyboardEvent & { target?: { id: string } }
    >(document, 'keyup').subscribe(event => {
      const isCorrectTarget = event.target?.id === this.id();
      if (event.key === 'Enter' && isCorrectTarget) {
        event.preventDefault();
        this.isExtended = !this.isExtended;
        this.cdRef.detectChanges();
      }
    });
  }

  ngOnDestroy() {
    this.$handleKeyUpEvent.unsubscribe();
  }
}
